// extracted by mini-css-extract-plugin
module.exports = {"menu":"_6bfdd5d","option":"_dbc9478"};